var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("table", { staticClass: "table bg-white table-bordered" }, [
    this.response.method !== "Structural Similarity Index Measure"
      ? _c("tbody", [
          _c("tr", [
            _c("td", [_c("span", [_vm._v(_vm._s(_vm._f("trans")("Method")))])]),
            _vm._v(" "),
            _c("td", [_c("span", [_vm._v(_vm._s(this.response.method))])]),
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_c("span", [_vm._v(_vm._s(_vm._f("trans")("All")))])]),
            _vm._v(" "),
            _c("td", [
              _c("span", [
                _vm._v(_vm._s(this.factors.all) + " "),
                this.response.method === "Absolute Error Count"
                  ? _c("span", [_vm._v(_vm._s(_vm._f("trans")("Pixels")))])
                  : _vm._e(),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_c("span", [_vm._v(_vm._s(_vm._f("trans")("Blue")))])]),
            _vm._v(" "),
            _c("td", [
              _c("span", [
                _vm._v(_vm._s(this.factors.blue) + " "),
                this.response.method === "Absolute Error Count"
                  ? _c("span", [_vm._v(_vm._s(_vm._f("trans")("Pixels")))])
                  : _vm._e(),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_c("span", [_vm._v(_vm._s(_vm._f("trans")("Green")))])]),
            _vm._v(" "),
            _c("td", [
              _c("span", [
                _vm._v(_vm._s(this.factors.green) + " "),
                this.response.method == "Absolute Error Count"
                  ? _c("span", [_vm._v(_vm._s(_vm._f("trans")("Pixels")))])
                  : _vm._e(),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_c("span", [_vm._v(_vm._s(_vm._f("trans")("Red")))])]),
            _vm._v(" "),
            _c("td", [
              _c("span", [
                _vm._v(_vm._s(this.factors.red) + " "),
                this.response.method == "Absolute Error Count"
                  ? _c("span", [_vm._v(_vm._s(_vm._f("trans")("Pixels")))])
                  : _vm._e(),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _vm.showPercentDiff()
            ? _c("tr", { staticClass: "font-weight-bold" }, [
                _c("td", [
                  _c("span", [_vm._v(_vm._s(_vm._f("trans")("Difference")))]),
                ]),
                _vm._v(" "),
                _c("td", [_c("span", [_vm._v(_vm._s(_vm.percentDiff) + "%")])]),
              ])
            : _vm._e(),
        ])
      : _c("tbody", [
          _c("tr", [
            _c("td", [_c("span", [_vm._v(_vm._s(_vm._f("trans")("Method")))])]),
            _vm._v(" "),
            _c("td", [_c("span", [_vm._v(_vm._s(this.response.method))])]),
          ]),
          _vm._v(" "),
          _c("tr", { staticClass: "font-weight-bold" }, [
            _c("td", [
              _c("span", [_vm._v(_vm._s(_vm._f("trans")("Image Similarity")))]),
            ]),
            _vm._v(" "),
            _c("td", [
              _c("span", [
                _vm._v(_vm._s((this.factors.all * 100).toFixed(2)) + "%"),
              ]),
            ]),
          ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }